export type typeModifires = string | string[] | undefined | boolean

export const mapModifires = (base: string, modifires: typeModifires): string[] => {
  if (typeof modifires === 'undefined' || typeof modifires === 'boolean') {
    return [base]
  }
  if (typeof modifires === 'string') {
    return [base, `${base}--${modifires}`]
  }
  return [base, ...modifires.map((str) => `${base}--${str}`)]
}

export const mergeModifires = (...modifires: typeModifires[]): string[] => {
  return (modifires.flat() as string[]).filter(Boolean)
}
